import {Component, Input} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {Company} from "../../../shared/api/companies/api.models";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Api} from "../../../shared/api.service";

@Component({
    selector: 'user-modal',
    template: require('./company.modal.html'),
    styles: [require('./company.modal.scss')]
})

export class CompanyModal {
    @Input() companies: Company[]
    @Input() company: Company;

    protected apiError: string;
    protected companyForm: FormGroup;

    constructor(public activeModal: NgbActiveModal, private fb: FormBuilder, private api: Api) {}

    trimField(field: string) {
        let value     = this.companyForm.controls[field].value;
        let corrected = value ? value.trim() : value;

        if (corrected !== value) {
            this.companyForm.controls[field].setValue(corrected);
            this.companyForm.controls[field].updateValueAndValidity();
        }
    }

    ngOnInit() {
        this.companyForm = this.fb.group({
            id   : [this.company.id],
            name : [
                this.company.name,
                [
                    Validators.required,
                    Validators.minLength(4),
                    Validators.maxLength(120),
                    Validators.pattern(/^[0-9a-zA-Z\s\.\-]+$/),
                    (input: FormControl) => {
                        if (!input.value) {
                            return null;
                        }

                        let found = false;

                        for (let i = 0; i < this.companies.length; i++) {
                            if (
                                this.companies[i].name.toLowerCase() === input.value.toLowerCase() &&
                                this.companies[i].id !== this.company.id
                            ) {
                                found = true;
                                break;
                            }
                        }

                        if (found === true) {
                            return { nametaken: true };
                        }

                        return null;
                    }
                ]
            ],
            description : [
                this.company.description,
                [
                    Validators.maxLength(255)
                ]
            ],
            manager : [
                this.company.manager,
                [
                    Validators.required,
                    Validators.minLength(4),
                    Validators.maxLength(50),
                    Validators.pattern(/^[0-9a-zA-Z\s\.]+$/),
                ]
            ],
        });

        this.companyForm.valueChanges.subscribe((company: Company) => {
            Object.assign(this.company, company);
        });
    }

    save() {
        this.apiError = null;

        if (this.company.id) {
            this.api.companies().update(this.company).subscribe(
                (company: Company) => {
                    this.activeModal.close(company);
                },
                (error: any) => {
                    if (error.errors) {
                        this.apiError = error.errors[0].detail;
                    } else {
                        this.apiError = error.error.message;
                    }
                }
            )

            return;
        }

        this.api.companies().add(this.company).subscribe(
            (company: Company) => {
                this.activeModal.close(company);
            },
            (error: any) => {
                if (error.errors) {
                    if (error.errors[0].title === 'already_exists') {
                        let control = this.companyForm.controls['name'] as FormControl;
                        control.setErrors({'nametaken' : true});
                    } else {
                        this.apiError = error.errors[0].detail;
                    }
                } else {
                    this.apiError = error.error.message;
                }
            }
        )
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/settings/companies/components/company.modal.ts